import CustomizedTitle from '../../../components/customizedTitle/CustomizedTitle2';
import ButtonController from '../../../components/containers/buttonController.js';
import ChartController from '../../../components/containers/chartController';
import useComponentIds from '../../../hooks/components/useComponentIds.js';
import usePageView from '../../../hooks/analytics/usePageView.js';
import Widget from '../../../components/common/widget/Widget';
import CircularProgress from '@mui/material/CircularProgress';
import Sidebar from '../../../components/sidebar/Sidebar';
import NavBar from '../../../components/navbar/NavBar';
import verifyToken from "../../../utils/tokenUtils.js";
import { useNavigate} from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import "./homepage.css";

const HomePage = () => {
  const navigate = useNavigate();
  usePageView();
  const [widgetLayouts, setWidgetLayouts] = useState({});
  const firstName = localStorage.getItem("name");
  const titleObject = {title: firstName ? `Welcome ${firstName}!` : "Welcome!"};
  const getAuthToken = () => { return Cookies.get('gtms-cp-auth'); };
  const getRole = () => { return Cookies.get('cp-role') };

  useEffect(() => {
    const token = getAuthToken();
    const role = getRole();
    if (role == 'VENDOR') { navigate('/formslanding') }
    token ? verifyToken(token) : navigate('/');
  }, []);

  const role = getRole();
  const componentIds  = useComponentIds(role);

  const handleWidgetLayoutChange = (widgetId, layoutVariant) => {
    setWidgetLayouts((currentLayouts) => {
      if (currentLayouts[widgetId] === layoutVariant) {
        return currentLayouts;
      }

      return {
        ...currentLayouts,
        [widgetId]: layoutVariant,
      };
    });
  };

  return (
  <div className='homepage'>
    <div className="homepageContainer">
      <NavBar/>
      <Sidebar/>
      <div className="homepageContent">
      <div className="homepageShell">
      <div className="homepageTop">
        <div className="homepageTitleCard">
          <CustomizedTitle titleObject={titleObject}/>
        </div>
      </div>
      <div className="homepageMid">
        <div className='widgets'>
          {componentIds && componentIds.widgets.length > 0 ? (
            <div className="widgetContainer">
              {componentIds.widgets.map((widgetId) => (
                <div className={`widgetBox widgetBox--${widgetLayouts[widgetId] || 'standard'}`}
                  key={`widget-${widgetId}`}
                >
                  <Widget type={{widgetId: widgetId}} onLayoutChange={handleWidgetLayoutChange} />
                </div>
              ))}
            </div>
          ): null}
        </div>
        <div className='badgeBox homepageCard'>
          <div className="homepageSectionHeader">
            <p className="homepageSectionEyebrow">Service Snapshot</p>
            <h2>At-a-glance services</h2>
          </div>
          <ChartController chartId={10} />
        </div>
        <div className="components homepageCard">
          <div className="homepageSectionHeader">
            <p className="homepageSectionEyebrow">Dashboard Detail</p>
            <h2>Operational charts</h2>
          </div>
          {componentIds === null ? (
            <div className="homepageLoadingState">
              <CircularProgress />
            </div>
          ) : componentIds.charts.length > 0 ? (
            <div className="flexContainer">
              {componentIds.charts.map((chartId) => (
                <div className="chartBox" key={`chart-${chartId}`}>
                  <ChartController chartId={chartId} />
                  <ButtonController chartId={chartId} />
                </div>
              ))}
            </div>
          ) : (
            <div className="chartBox homepageEmptyState" key="chart-0">
              <p>Welcome to your dashboard. There are no components available.</p>
              <p>Please contact GTMS to specify what you want shown here.</p>
            </div>
          )}
        </div>
      </div>
      </div>
      <div className="homepageBottom"></div>
      </div>
    </div>
  </div>
  )
}

export default HomePage
